<div
  (dblclick)="editTodo()"
  [class.highlight]="highlighted()"
  [class.is-archived]="todo().state !== TodoState.ACTIVE && todo().completion !== TodoCompletion.DONE"
  [class.is-done]="todo().completion === TodoCompletion.DONE"
  class="todo-card group flex flex-col gap-2 rounded-xl border px-2.5 py-2 cursor-grab shadow relative overflow-hidden transition-all duration-200 hover:shadow-md hover:-translate-y-px hover:border-primary-200"
>

  <div class="flex items-center justify-between">
    <div class="flex items-start text-sm font-medium min-w-0">
      <span (click)="$event.stopPropagation()" class="card-checkbox shrink-0">
        <p-checkbox (onChange)="toggleCompletion()" [binary]="true" [formControl]="completionControl"/>
      </span>

      <span class="flex gap-1">
         @if (todo().isPrivate) {
           <elcia-icon [iconType]="'lock'"/>
         }
        <span (click)="editTodo()" class="hover:underline cursor-pointer">{{ todo().title }}</span>
      </span>
    </div>

    <div class="flex items-center gap-1 shrink-0">
      @if (todo().dueDate) {
        <div [class]="todo().dueDate | dueDateClass" [pTooltip]="todo().dueDate | dueDateFull" tooltipPosition="top">
          {{ todo().dueDate | dueDateFormat }}
        </div>
      }

      @if (todo().priority) {
        <elcia-todo-priority-indicator [priority]="todo().priority!"/>
      }
    </div>
  </div>


  <div class="flex items-center font-medium line-clamp-1 text-xs text-gray-500">
    <div class="w-2/4">
      @if (todo().concern) {
        <a [routerLink]="concernRouterLink()" class="hover:underline" target="_blank">
          <span>{{ todo().concern!.fullName }}</span>
        </a>
      }
    </div>


    <div class="w-2/4 flex items-center justify-end gap-1">
      @if (todo().assignees) {
        <elcia-avatar [avatars]="todo().assignees!" [maxItem]="4"/>
      }
    </div>


  </div>

  <div class="grid grid-cols-3 items-center">
    <div></div>
    <div class="flex justify-center">
      @if (todo().childCount) {
        <elcia-sub-todo-expander
          (onExpandClick)="expanded.update(v => !v)"
          [done]="childrenDone()"
          [expanded]="expanded()"
          [total]="todo().childCount"/>
      }
    </div>
    <div class="flex items-center justify-end">
      @let durationInDays = todo().totalDurationInSeconds | durationInDays;
      @let estimatedTimeInDays = todo().estimatedTimeInDays;
      @if (durationInDays && estimatedTimeInDays) {
        @let isOver = durationInDays > estimatedTimeInDays;
        <span class="text-xs {{isOver ? 'text-red-400 font-bold' : 'text-gray-500 font-medium'}}">
          {{ todo().totalDurationInSeconds | durationInDays }}
          /{{ todo().estimatedTimeInDays }}{{ 'date.day' | translate }}
        </span>
      }
    </div>
  </div>

  @if (expanded() && todo().children.length) {
    <div [animate.enter]="'subtask-expand'" [animate.leave]="'subtask-collapse'" class="subtasks-container mt-3">
      @for (child of todo().children; track $index) {
        <elcia-todo-kanban-card-sub-todo (onToggleState)="onChildCompletionChange.emit($event)"
                                         [highlighted]="child.id === highlightChildId()" [itemIndex]="$index"
                                         [style.--subtask-index]="$index"
                                         [subTodo]="child"/>
      }
    </div>
  }
</div>
